import {
  modifySignup,
  toggleMobileMenu,
  fixSearchFocus,
  fixFeatureButton,
  removeFocusCart,
  footerLayout,
} from '../js/helpers/helpers';

$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  fixFeatureButton();
  toggleMobileMenu();
  fixSearchFocus();
  modifySignup();
  footerLayout();
  removeFocusCart();
  $('.featureLineupContainer .featureLineup-text').wrapInner('<p></p>');
});

$(globalThis).on('resize', footerLayout);
